import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0),
    backgroundColor: 'transparent',

    '& .course': {
      '&-header': {
        display: 'flex',
        height: theme.spacing(11),
        padding: theme.spacing(0),

        [theme.breakpoints.down('xs')]: {
          height: theme.spacing(14),
        },

        '&:hover': {
          backgroundColor: theme.palette.custom.surface[1],
        },

        '&-button': {
          display: 'flex',
          width: '100%',
          padding: theme.spacing(2, 3),
        },

        '&-chart': {
          '&, &-lock': {
            marginRight: theme.spacing(2),
          },
          '&-lock': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.text.disabled,
            border: `solid 3px ${theme.palette.custom.surface[2]}`,
            borderRadius: '50%',
            width: theme.spacing(6) - 3,
            height: theme.spacing(6) - 3,
          },
        },

        '&-text': {
          '&-container': {
            display: 'flex',
            alignItems: 'flex-start',
            flexGrow: 1,

            '&-start': {
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
              alignItems: 'flex-start',
              margin: theme.spacing(0, 1, 0, 0),
              flexGrow: 1,
            },

            '&-end': {
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
              alignItems: 'flex-end',
              textAlign: 'right',
              margin: theme.spacing(0, 1, 0, 0),
            },

            [theme.breakpoints.down('xs')]: {
              flexDirection: 'column',

              '&-start': {
                margin: theme.spacing(1, 0, 0, 0),
              },
              '&-end': {
                margin: theme.spacing(1, 0, 0, 0),
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                textAlign: 'left',
              },
            },
          },

          '&-title': {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
            '&.lock': {
              color: theme.palette.text.hint,
            },
          },
          '&-teacher': {
            color: theme.palette.text.hint,
          },
          '&-lock': {
            color: theme.palette.text.hint,
          },
          '&-expiration-date': {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
          },
          '&-register-date': {
            color: theme.palette.text.hint,
          },
        },
        '&-icon': {
          '&-expand': {
            color: theme.palette.text.hint,
          },
          '&-lock': {
            color: theme.palette.text.disabled,
          },
        },
      },

      '&-body': {
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(1, 0),
        },

        '&-content': {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          margin: theme.spacing(1, 0, 0, 8),
          overflow: 'hidden',
          width: '100%',

          [theme.breakpoints.down('sm')]: {
            margin: 0,
          },
        },

        '&-list': {
          '&-title': {
            color: theme.palette.text.hint,
            [theme.breakpoints.down('sm')]: {
              marginLeft: theme.spacing(3),
            },
          },
          '&-content': {
            '&.next': {
              marginBottom: theme.spacing(2),
            },
            '&.next-lesson-error-container': {
              display: 'flex',
              border: `solid 1px ${theme.palette.divider}`,
              borderRadius: theme.shape.borderRadius,
              backgroundColor: theme.palette.custom.background.area,

              '& .next-lesson-error': {
                '&-icon': {
                  color: theme.palette.custom.feedback.warning,
                  marginRight: theme.spacing(2),
                },
                '&-content': {
                  display: 'flex',
                  flexGrow: 1,
                },
              },
              [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(1, 1, 1, 2),
                alignItems: 'center',
                '& .next-lesson-error': {
                  '&-content': {
                    alignItems: 'center',

                    '&-button': {
                      margin: '0 0 0 auto',
                    },
                  },
                },
              },
              [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(2),
                margin: theme.spacing(0, 3, 2),
                width: 'auto',
                '& .next-lesson-error': {
                  '&-content': {
                    flexDirection: 'column',
                    alignItems: 'flex-start',

                    '&-button': {
                      margin: `${theme.spacing(1)}px auto 0 0`,
                    },
                  },
                },
              },
            },

            [theme.breakpoints.up('sm')]: {
              width: '100%',
              padding: 0,
              margin: theme.spacing(0, 0, 1, 0),
            },
            [theme.breakpoints.down('sm')]: {
              padding: theme.spacing(0, 3),
            },
          },
        },
      },
    },
  },

  containerDisabled: {
    backgroundColor: ['transparent', '!important'],
  },

  containerExpanded: {
    backgroundColor: theme.palette.custom.surface[1],
    margin: [[theme.spacing(0)], '!important'],
  },

  headerContent: {
    margin: [[theme.spacing(0)], '!important'],
    height: '100%',
  },
  headerContentDisabled: {
    opacity: [1, '!important'],
  },
}));

export default styles;
